import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";

export class ProgramTemplatesViewCtrl implements IController {

  programTypes: any;
  selectedProgramType: any;

  public programTemplates: any;

  /* @ngInject */
  constructor(private PricePlanService, private $state, private pricePlanDialogService: PricePlanDialogService, private $log) {
  }

  $onInit() {
    if (!this.selectedProgramType) {
      this.selectedProgramType = this.programTypes[0].id;
      this.$state.go('.', {programType: this.selectedProgramType}, {notify: false, reload: false});
    }

    this.getTemplates(this.selectedProgramType);
  }

  onProgramTypeSelect(selectedProgramType) {
    this.getTemplates(selectedProgramType);
    // this.$state.go('.', {programType: selectedProgramType}, {notify: true, reload: false});
  }

  onCreateTemplate(event) {
    this.pricePlanDialogService.createTemplate(event)
      .then((name) => {
        this._createTemplate(this.selectedProgramType, name);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      })
  }

  // private getTemplates(ProgramTypeId) {
  //   this.PricePlanRequests.getTemplatesByType(ProgramTypeId)
  //     .then((programTemplates) => {
  //       this.programTemplates = programTemplates;
  //     })
  // }
  //
  // private _createTemplate(type, name) {
  //   this.PricePlanRequests.createTemplate(type, name)
  //     .then((newTemplate) => {
  //       if (!this.programTemplates) {
  //         this.programTemplates = [];
  //       }
  //       this.programTemplates.unshift(newTemplate)
  //     })
  // }

  private getTemplates(ProgramType) {
    this.PricePlanService.getTemplatesByType(ProgramType)
      .then((programTemplates) => {
        this.programTemplates = programTemplates;
        this.$state.go('.', {programType: ProgramType, programId: _.get(programTemplates, '[0].id')}, {notify: true, reload: false});
      })
  }

  private _createTemplate(type, name) {
    this.PricePlanService.createTemplate(type, name)
      .then((newTemplate) => {
        if (!this.programTemplates) {
          this.programTemplates = [];
        }
        this.programTemplates.unshift(newTemplate)
      })
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programTemplatesView', {
    bindings : {
      programTypes: '<',
      selectedProgramType: '<'
    },
    template: require('./program-templates-view.html').default,
    controller : ProgramTemplatesViewCtrl
  });
